import { render, staticRenderFns } from "./TransferReceiptVoucherForm.vue?vue&type=template&id=12793bbf"
import script from "./TransferReceiptVoucherForm.vue?vue&type=script&lang=js"
export * from "./TransferReceiptVoucherForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports